<template>
  <section>
    <b-row class="match-height">
      <b-col
        v-if="transaction"
        lg="6"
        md="6"
      >
        <Card
          :transaction="transaction"
          :app="app"
          :uuid="selected.uuid"
          :status="statusSelected"
          :store="selected"
          :avatar="avatar"
          :period="period"
          @changeCount="changeCount"
        />
      </b-col>

      <b-col
        lg="6"
        md="6"
      >

        <b-card
          no-body
          class="mb-2"
        >
          <b-card-header>
            <h4 class="mb-0">
              Filtros
            </h4>
          </b-card-header>

          <b-card-body>
            <b-overlay
              :show="overlay"
              spinner-variant="primary"
              spinner-type="grow"
              spinner-small
              rounded="sm"
            >
              <b-row>
                <b-col>
                  <b-form-group>
                    <h5>Loja</h5>
                    <v-select
                      v-model="selected"
                      label="name"
                      :options="stores"
                      placeholder="Selecione"
                    />
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group>
                    <h5>Status</h5>
                    <v-select
                      v-model="statusSelected"
                      label="status"
                      :options="statuses"
                      placeholder="Selecione"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <div>
                    <label for="example-datepicker">A partir de: </label>
                    <b-form-datepicker
                      id="example-datepicker"
                      v-model="period"
                      class="mb-1"
                    />
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="app"
                    name="check-button"
                    switch
                    inline
                  >
                    abrir app do whatsapp
                  </b-form-checkbox>
                </b-col>
                <!--
                            <b-col>
                            <b-form-group>
                                <v-select
                                v-model="temperatura"
                                label="temperatura"
                                :options="temperaturas"
                                class="select-size-sm"
                                placeholder="Ordenar temperatura"
                                />
                            </b-form-group>
                            </b-col>
                            -->
              </b-row>

              <br>

              <b-row>
                <b-button
                  block
                  variant="primary"
                  @click="filter()"
                >
                  Buscar
                </b-button>
              </b-row>
            </b-overlay>
          </b-card-body>

          <hr class="mb-2">

          <b-row>
            <b-col class="ml-2">
              <feather-icon icon="UsersIcon" /> <h5 v-if="transaction">
                {{ transaction.total }}
              </h5> <h5 v-else>
                0
              </h5>
            </b-col>

          </b-row>

        </b-card>
      </b-col>

    </b-row>
    <br><br>
    <b-card>
      <h3>últimos Contatados</h3>
      <b-button
        v-b-modal.modal-xl
        variant="warning"
        class="btn-icon"
        @click="history()"
      >
        <feather-icon icon="ArchiveIcon" />
        Abrir Histórico
      </b-button>

      <b-row>
        <b-col
          v-for="transactionCache in transactionsCache"
          lg="4"
          md="4"
        >
          <CardTeste
            :transaction="transactionCache.transaction"
            :subattending="transactionCache.transaction.subattending_id"
            :store="selected"
            :app="app"
            @scheduleSubattending="scheduleSubattending"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-xl"
      close-only
      centered
      size="xl"
      title="Histórico de Atendimento"
    >
      <b-row class="d-flex">
        <b-col
          lg="4"
          class="mb-1"
        >
          <!-- button on right -->
          <b-input-group>
            <b-form-input
              v-model="search"
              placeholder="Buscar por nome, CPF, whatsapp ou e-mail "
            />
            <b-input-group-append>
              <b-button
                variant="outline-primary"
                :disabled="searchButton"
                @click="page = 1, history() "
              >
                Buscar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <!-----<b-card-text></b-card-text> -->
      <b-overlay
        :show="overlayHistory"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-pagination-nav
          v-model="page"
          :number-of-pages="pagesTotal"
          base-url="#"
          first-number
        />
        <b-row>
          <b-col
            v-for="transactionHistory in transactionsHistory"
            lg="4"
            md="4"
          >
            <CardTeste
              :transaction="transactionHistory.transaction"
              :subattending="transactionHistory"
              :store="selected"
              @scheduleSubattending="scheduleSubattending"
              @salesCustomer="salesCustomer"
            />
          </b-col>
        </b-row>
        <b-pagination-nav
          v-model="page"
          :number-of-pages="pagesTotal"
          base-url="#"
          first-number
        />
      </b-overlay>
    </b-modal>

    <schedule :subattending="teste" />
    <b-modal
      id="modal-tall"
      title="Histórico da Cliente"
      cancel-variant="outline-secondary"
      cancel-title="Close"
    >
      <b-card-text>

        <app-collapse v-for="sale in historyCustomer">

          <app-collapse-item :title="sale.codigo + ' ' + sale.pedidoSituacaoDescricao">

            R${{ sale.valorTotal }} {{ sale.condicaoPagamentoNome }} no {{ sale.formaPagamentoNome }}, o pedido foi realizado no dia {{ sale.dataHora }}

          </app-collapse-item>

        </app-collapse>
      </b-card-text>
    </b-modal>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BFormInput, BFormGroup, BButton, BFormCheckbox, BModal, VBModal, BInputGroup, BInputGroupAppend, BInputGroupPrepend, BOverlay,
  BFormDatepicker, BPaginationNav,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { getUserData } from '@/auth/utils'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Card from './cards.vue'
import CardTeste from './cardsTeste.vue'
import Filters from './filters.vue'
import attending from '../../../functions/basics/attending'
import schedule from '../../schedule/editSchedule.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    BFormGroup,
    Card,
    CardTeste,
    Filters,
    vSelect,
    BFormDatepicker,
    BButton,
    BFormCheckbox,
    AppCollapse,
    AppCollapseItem,
    VBModal,
    BPaginationNav,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BOverlay,
    ToastificationContent,
    schedule,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    scheduleSubattending: Object,
    salesCustomer: Object,
  },
  data() {
    return {
      stores: [],
      selected: null,
      statuses: [],
      statusSelected: null,
      transaction: null,
      app: false,
      transactionsCache: null,
      transactionsHistory: null,
      pagesTotal: null,
      page: 1,
      search: '',
      overlay: false,
      overlayHistory: false,
      searchButton: false,
      period: new Date().toISOString().slice(0, 10),
      avatar: null,
      teste: null,
      historyCustomer: null,
      temperaturas: [{ temperatura: 'quente' }, { temperatura: 'morno' }, { temperatura: 'frio' }],
    }
  },
  watch: {
    async selected(newStores, oldStores) {
      this.statusSelected = null
      const data = await getUserData()
      const statuses = await attending.getAttendingStatuses(data.mc_access_token, newStores.uuid)
      this.statuses = statuses.contact_statuses
    },
    page() {
      this.history()
    },
  },
  async created() {
    const data = await getUserData()
    this.stores = await attending.getAttendingStores(data.mc_access_token)
  },
  methods: {
    showToast(variant, message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notificação',
          icon: 'BellIcon',
          text: message,
          variant,
        },
      })
    },
    async filter() {
      if (new Date(this.period) < new Date('2024-04-23')) {
        this.showToast('primary', 'Selecione apenas datas a partir de 23/04/2024')
      } else {
        this.overlay = true
        const data = await getUserData()
        const transaction = await attending.getAttending(data.mc_access_token, this.selected.uuid, this.statusSelected.id, this.period).then(resp => {
          this.showToast('success', `Foram encontrados ${resp.total} na fila!`)
          this.overlay = false
          return resp
        }).catch(error => {
          this.showToast('primary', 'Ops, não consegui encontrar nenhum card.')
          this.overlay = false

          return []
        })
        this.transaction = (transaction.subattending !== null) ? transaction : null
      }
    },
    updateTransactionsCache() {
      const transactions = JSON.parse(localStorage.getItem('transactions'))
      this.transactionsCache = [...transactions]
      console.log('esse daqui carregou', this.transactionsCache)
    },
    changeCount(value) {
      this.updateTransactionsCache()
      this.transaction = value
    },
    async history() {
      this.searchButton = true
      this.overlayHistory = true
      const data = await getUserData()
      const history = await attending.searchTransactions(data.mc_access_token, this.selected.uuid, this.page, this.search)
      this.transactionsHistory = history.data
      this.pagesTotal = history.last_page
      this.page = history.current_page
      this.overlayHistory = false
      this.searchButton = false
    },
    scheduleSubattending(value) {
      this.teste = value
    },
    salesCustomer(value) {
      this.historyCustomer = value
    },
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
